<div class="block md:hidden">
  <div class="flex justify-center items-center h-full">
    <button (click)="toggleSidebar()" class="w-16 bg-gray-100 h-[100vh]">
      <i class="fa-solid fa-angles-down" [ngClass]="sidebarExpanded ? 'fa-rotate-90' : 'fa-rotate-270'"></i>
    </button>
  </div>
</div>
<div class="navigation-container" [class.expanded]="sidebarExpanded">
  <div class="expand md:hidden flex justify-end px-4 pt-4">
    <button (click)="toggleSidebar()">
      <i class="fa-light fa-times text-2xl"></i>
    </button>
  </div>
  <div class="px-4 pt-8 flex justify-start">
    <img src="assets/images/lfx-logo.svg" alt="Project Control Center Logo" class="w-auto max-h-5" />
  </div>
  <div class="pl-4 pr-1 pt-5 bg-white flex gap-2 items-center justify-between lfx-tools-container">
    <div class="flex gap-2 items-center">
      <div class="flex items-center justify-center">
        <i class="fa-server fa-duotone text-2xl"></i>
      </div>
      <span class="text-sm font-roboto font-semibold">Project Control Center</span>
    </div>
    <lfx-tools kit="49d4d32e47" product="project-control-center" class="hidden md:block"></lfx-tools>
  </div>

  @if (project?.ProjectLogo) {
    <div class="pl-4 pt-3">
      <div class="h-7 w-auto overflow-hidden">
        <img [src]="project?.ProjectLogo" [alt]="project?.Name" [title]="project?.Name" class="h-full w-auto object-contain" />
      </div>
    </div>
  }

  <div class="search-input pt-3">
    <lfx-global-search></lfx-global-search>
  </div>

  <div class="navigation" [class.expanded]="sidebarExpanded">
    <ng-container>
      <div class="navigation-wrapper">
        @if (!project?.Name) {
          <p-skeleton width="100%" height="30px" borderRadius="0"></p-skeleton>
        }

        <div class="navigation-group" *ngIf="project?.Name">
          <a
            class="navigation-group-title"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
            [routerLink]="['/project', projectID || linuxFoundationSFID]">
            <div class="flex items-center gap-2">
              <i class="fa-light fa-house"></i>
              <span>{{ project?.Name }}</span>
            </div>
          </a>
        </div>

        <ng-container *ngIf="projectID">
          <ng-container *ngIf="project$ | async as project">
            <div class="navigation-group" *ngFor="let nav of navItems; index as idx" data-cy="sidenav-group" [ngClass]="nav.active ? 'active' : ''">
              <a class="navigation-group-title" (click)="toggleDropdown(nav)" data-cy="sidenav-group-title">
                <div class="flex items-center gap-1">
                  <i [class]="nav.icon" [class.fas]="nav.active"></i>
                  <span>{{ nav.name }}</span>
                </div>
                <i class="fa-light" [ngClass]="nav.active ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              </a>
              <div class="wrapper" [ngStyle]="{ maxHeight: getNavGroupMaxHeight(nav.items, !nav.active) }">
                <div
                  class="navigation-item"
                  *ngFor="let item of nav.items"
                  [class.active]="item.active"
                  [routerLinkActive]="item.routerLink ? 'active' : ''"
                  data-cy="sidenav-group-items">
                  <div *ngIf="item.disabled" class="disabled">
                    <div class="w-[0.6rem]"></div>
                    <span>{{ item.name }}</span>
                    <div class="v1-link">
                      <p-tag severity="info" value="V1" pTooltip="This service will redirect you to PCC V1, and will soon be migrated."></p-tag>
                    </div>
                  </div>
                  <a
                    *ngIf="item.routerLink && !item.disabled && !item.hidden"
                    [routerLink]="item.routerLink ? item.routerLink : ''"
                    [routerLinkActive]="item.routerLink ? 'active' : ''"
                    [class.active]="item.active"
                    [class.disabled]="item.disabled">
                    <div class="w-[0.6rem]"></div>
                    <span>{{ item.name }}</span>
                  </a>
                  <a
                    *ngIf="item.slug && !item.disabled && !item.hidden"
                    [href]="item.slug"
                    [routerLinkActive]="item.routerLink ? 'active' : ''"
                    [class.active]="item.active"
                    [class.disabled]="item.disabled">
                    <div class="v1-link">
                      <div class="w-[0.6rem]"></div>
                      <span>{{ item.name }}</span>
                      <p-tag pTooltip="This service will redirect you to PCC V1, and will soon be migrated.">V1</p-tag>
                    </div>
                  </a>
                  <a *ngIf="item.url && !item.disabled && !item.hidden" [href]="item.url" [target]="item.target">
                    <div class="w-[0.6rem]"></div>
                    <span>{{ item.name }}</span>
                  </a>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <hr />
        <div class="dashboard-navigation" [class.all-projects]="!projectID">
          <div class="navigation-group">
            <div class="navigation-group-title" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="current">
              <a routerLink="/all-projects">
                <div class="flex items-center gap-2">
                  <i class="fa-light fa-laptop-code w-5"></i>
                  <span>All Projects</span>
                </div>
              </a>
            </div>
          </div>

          <ng-container *ngIf="user$ | async; else navigationGroupLoading">
            <ng-container *ngIf="assignedProjects$ | async as assignedProjects; else navigationGroupLoading">
              <div class="navigation-group">
                <a class="navigation-group-title" (click)="toggleGroupHeight('Assigned')">
                  <div class="flex items-center gap-2">
                    <i class="fa-light fa-laptop-code"></i>
                    <span class="text-sm">My Projects</span>
                  </div>
                  <i class="fa-light" [ngClass]="assignedProjectsCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                </a>

                <div class="no-projects" *ngIf="!assignedProjects?.length && !assignedProjectsCollapsed">
                  <span>No Assigned Projects</span>
                </div>

                <div
                  class="navigation-item-container"
                  [class.active]="assignedProjectsShowMore"
                  *ngIf="assignedProjects && assignedProjects.length"
                  [ngStyle]="{ maxHeight: getGroupMaxHeight(assignedProjects, assignedProjectsShowMore, assignedProjectsCollapsed) }">
                  <lfx-navigation-item *ngFor="let item of assignedProjects" [item]="item"></lfx-navigation-item>
                </div>
                <div class="show-more" *ngIf="assignedProjects.length > 3 && !assignedProjectsCollapsed">
                  <a (click)="toggleProjectHeight('Assigned Projects')">
                    <span>View {{ assignedProjectsShowMore ? 'Less' : 'More' }}</span>
                    <i class="fa-light" [ngClass]="assignedProjectsShowMore ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  </a>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="favoriteProjects$ | async as favoriteProjects; else navigationGroupLoading">
              <div class="navigation-group">
                <a class="navigation-group-title" (click)="toggleGroupHeight('Bookmarks')">
                  <div class="flex items-center gap-2">
                    <i class="fa-solid fa-star"></i>
                    <span class="text-sm">Bookmarks</span>
                  </div>
                  <i class="fa-light" [ngClass]="favoriteProjectsCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                </a>

                <div class="no-projects" *ngIf="!favoriteProjects?.length && !favoriteProjectsCollapsed">
                  <span>No Bookmarked Projects</span>
                </div>

                <div
                  class="navigation-item-container"
                  [class.active]="favoriteProjectsShowMore"
                  *ngIf="favoriteProjects && favoriteProjects.length"
                  [ngStyle]="{ maxHeight: getGroupMaxHeight(favoriteProjects, favoriteProjectsShowMore, favoriteProjectsCollapsed) }">
                  <lfx-navigation-item *ngFor="let item of favoriteProjects" [item]="item" [showFavorite]="true"></lfx-navigation-item>
                </div>
                <div class="show-more" *ngIf="favoriteProjects.length > 3 && !favoriteProjectsCollapsed">
                  <a (click)="toggleProjectHeight('Favorite Projects')">
                    <span>View {{ favoriteProjectsShowMore ? 'Less' : 'More' }}</span>
                    <i class="fa-light" [ngClass]="favoriteProjectsShowMore ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  </a>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <!-- Global Menu-->
          <div class="navigation-group" *ngIf="permissions$ | async as permissions">
            <a
              class="navigation-group-title"
              (click)="toggleGroupHeight('Global')"
              *ngIf="
                (permissions.surveys_schedule?.view && permissions.project_committee_surveys.view_all) ||
                permissions.project_committee_audit_user_global?.view_all
              ">
              <div class="flex items-center gap-2">
                <i class="fa-light fa-globe"></i>
                <span class="text-sm">Global</span>
              </div>
              <i class="fa-light" [ngClass]="globalCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
            </a>
            <div>
              <div *ngIf="!globalCollapsed" class="wrapper">
                <div *ngIf="permissions.surveys_schedule?.view && permissions.project_committee_surveys.view_all" class="navigation-item">
                  <a routerLink="/global-surveys" routerLinkActive="active">
                    <div class="w-[0.8125rem]"></div>
                    <span>Surveys</span>
                  </a>
                </div>
                <div *ngIf="permissions.project_committee_audit_user_global?.view_all" class="navigation-item">
                  <a routerLink="/global-committee-audit" routerLinkActive="active">
                    <div class="w-[0.8125rem]"></div>
                    <span>Committee Audit</span>
                  </a>
                </div>
                <div *ngIf="permissions.project_summary.view_all" class="navigation-item">
                  <a routerLink="/project-formation" routerLinkActive="active">
                    <div class="w-[0.8125rem]"></div>
                    <span>Project Formation</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- End Global Menu-->
        </div>
        <div class="absolute bottom-0 w-full bg-white border-t border-gray-light shadow-sm">
          <div class="navigation-group">
            <a class="navigation-group-title" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active" routerLink="/changelog">
              <div class="flex items-center justify-between gap-2 w-full">
                <div class="flex items-center gap-2">
                  <i class="fa-light fa-clock-rotate-left"></i>
                  <span>Changelog</span>
                </div>

                @if (unseenChangelogCount() > 0) {
                  <p-badge size="small" [value]="unseenChangelogCount().toString()" severity="danger" />
                }
              </div>
            </a>
          </div>
          <div class="navigation-group">
            <a
              class="navigation-group-title"
              href="https://docs.linuxfoundation.org/lfx/project-control-center/v2-latest-version/overview"
              target="_blank"
              rel="noopener noreferrer">
              <div class="flex items-center gap-2">
                <i class="fa-light fa-book"></i>
                <span>Documentation</span>
              </div>
            </a>
          </div>
          <div class="navigation-group">
            <button pButton class="p-button-text w-full navigation-group-title" lfxOpenIntercom>
              <div class="flex items-center gap-2">
                <i class="fa-light fa-circle-question"></i>
                <span>Support</span>
              </div>
            </button>
          </div>
          @if (user()?.Name) {
            <div class="navigation-group">
              <button type="button" class="navigation-group-title w-full" (click)="op.toggle($event)">
                <div class="flex items-center gap-2">
                  @if (user()?.LogoURL) {
                    <p-avatar [image]="user()?.LogoURL" (onImageError)="onImageError($event)" size="normal" styleClass="object-cover w-5 h-5" />
                  } @else {
                    <p-avatar icon="fa-light fa-user" styleClass="bg-transparent text-surface-400" />
                  }
                  <span>{{ user()?.Name }}</span>
                </div>
              </button>
              <p-popover #op styleClass="user-menu-popover" appendTo="body">
                <p-menu [model]="userMenuItems()" />
              </p-popover>
            </div>
          } @else {
            <p-skeleton width="100%" height="30px" borderRadius="0"></p-skeleton>
          }
        </div>
      </div>
    </ng-container>
  </div>
  <ng-template #navigationGroupLoading>
    <p-skeleton width="100%" height="30px" borderRadius="0"></p-skeleton>
  </ng-template>
</div>
